export interface ICreateClientDTO {
  cellPhone: string;
  email: string;
  atSign: string;
  name: string;
  documentType?: number;
  document?: string;
  language: string;
  photos: string;
}

export interface ICreateClientPublicDTO {
  name: string;
  atSign: string;
  language: string;
  photos: string;
}

export enum ClientStatusEnum {
  ACTIVE = "a",
  INACTIVE = "i",
  DELETED = "x",
  PENDING = "p",
}

export type ClientStatusTypes = `${ClientStatusEnum}`;

export enum ClientTypeEnum {
  GUEST = "g",
  CLIENT = "c",
}

export type ClientTypeTypes = `${ClientTypeEnum}`;

export interface IClientStatusDTO {
  status: ClientStatusTypes | string;
  text: string;
  title: string;
  color: string;
}

export interface IClientTypeDTO {
  type: ClientTypeTypes | string;
  text: string;
  title: string;
  color: string;
}

export interface IClientPublicListDTO {
  id: number;
  type: ClientTypeTypes;
  atSign?: string | null;
  cellPhone?: string | null;
  email?: string | null;
  name?: string | null;
  documentType?: number;
  document?: string;
  language: string;
  status: ClientStatusTypes;
  createdAt: string;
  updatedAt: string;
}
